export default defineNuxtRouteMiddleware((to) => {
	const paths = [
		'/o-nas/dokumenty-vernostniho-programu/vseobecne-podminky',
		'/o-nas/dokumenty-vernostniho-programu/informace-o-ochrane-a-zpracovani-osobnich-udaju',
		'/o-nas/dokumenty-vernostniho-programu/souhlas-se-zpracovanim-osobnich-udaju',
	];

	if (paths.includes(to.path) && to.query.hideHeader) {
		setPageLayout('simple');
	}
});
